module.exports = __webpack_public_path__ + "img/b_immun_up.ee777df1.jpeg";